/**
 * PREVIEW ENTITY REDUX ACTIONS
 *
 * Description here.
 *
 * @version 0.1
 */

import reduxStore from '../../reduxStore';
import utils from '../../utils/utilities';
import xhr from '../../utils/xhr';

import commonActions from '../../api/Common.actions';

// Define action constants\
export const SET_COMPANY_DATA = 'SET_COMPANY_DATA';
export const SET_RETURN_FROM_ARTICLE_PAGE_FLAG = 'SET_RETURN_FROM_ARTICLE_PAGE_FLAG';
export const PREVIEW_TABLE_URL_CHANGE = 'PREVIEW_TABLE_URL_CHANGE';

const actions = {

    setCompanyData: (companyData) => {
        reduxStore.dispatch({
            type:    SET_COMPANY_DATA,
            payload: companyData
        });
    },

    saveCompany: (companyData) => {
        return xhr.post({
            url:  '/api/entities/company',
            data: companyData,
        });
    },

    persistPreferences: (urlParams) => {
        reduxStore.dispatch({
            type:    PREVIEW_TABLE_URL_CHANGE,
            payload: urlParams
        });

        commonActions.updateUserPrefs({
            articlesLanguageFilter: urlParams.language,
            previewCompany: {
                sortBy:    urlParams.sortBy,
                direction: urlParams.direction,
                riskAngle: urlParams.riskAngle,
                riskLevel: urlParams.riskLevel
            }
        })
    },

    setReturnFromArticlePageFlag: (flagValue) => {
        reduxStore.dispatch({
            type:    SET_RETURN_FROM_ARTICLE_PAGE_FLAG,
            payload: flagValue
        });
    },

    addLabel: (companyData, labelsFieldName, labelValue) => {

        let newCompanyData = utils.deepClone(companyData);
        newCompanyData[labelsFieldName].push(labelValue);

        actions.setCompanyData(newCompanyData);

        // This method needs to be thenable in order to be compatible with the Preview Entity panel
        return Promise.resolve(newCompanyData);
    },

    removeLabel: (companyData, labelsArrayName, labelIndex) => {

        let newCompanyData = utils.deepClone(companyData);
        newCompanyData[labelsArrayName].splice(labelIndex, 1);

        actions.setCompanyData(newCompanyData);
        // This method needs to be thenable in order to be compatible with the Preview Entity panel
        return Promise.resolve(newCompanyData);
    }

};

export default actions;


// WEBPACK FOOTER //
// ./src/scripts/pages/CreateNewEntity/CreateNewEntity.actions.js